import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import styles from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/budget-editor.module.scss'
import BudgetsList from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/BudgetsList'
import DatesList from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/DatesList'
import { useDispatch, useSelector } from 'react-redux'
import { UPDATE_ROW } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/types'
import { Grid } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'

const ModifyList = ({ type, resource }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const ListComponent = useMemo(() => {
    switch (type) {
      case 'budget':
        return BudgetsList
      case 'dates':
        return DatesList
      default:
        return null
    }
  }, [type])

  const { rows } = useSelector((state) => ({
    rows: state['services/budget-editor'][type].rows,
  }))

  const updateRow = useCallback(
    (external_id, update) => dispatch({ type: UPDATE_ROW, payload: { type, external_id, update } }),
    [type],
  )

  return (
    <div className={styles['budget-editor__list-wrapper']}>
      <ListComponent
        type={type}
        rows={rows}
        updateRow={updateRow}
        resource={resource}
        EmptyComponent={() => (
          <Grid justifyContent={'center'}>
            {t('campaigns_editor::budget_editor.table.empty_label', {
              context: resource,
            })}
          </Grid>
        )}
      />
    </div>
  )
}

export default ModifyList

ModifyList.propTypes = {
  type: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  config: PropTypes.func,
  tableConfig: PropTypes.object,
}
